<!-- unlimited -->
<agpr-message
    *ngIf="unsavedMentionExportLimit == -1"
    [severity]="messageSeverities.info"
>
    <span [innerHTML]="mentionType+'.postFeed.bulkActions.unusedMention.message.unlimited' | localize : {
        unsavedCount: unsavedMentionQuotaUsage
    }"></span>
</agpr-message>

<!-- no access -->
<agpr-message
    *ngIf="unsavedMentionExportLimit == 0"
    [severity]="messageSeverities.error"
>
    <span [innerHTML]="mentionType+'.postFeed.bulkActions.unusedMention.message.noAccess' | localize"></span>
</agpr-message>

<!-- no mention selected -->
<agpr-message
    *ngIf="mentionCount == 0"
    [severity]="messageSeverities.error"
>
    <span [innerHTML]="mentionType+'.postFeed.bulkActions.unusedMention.message.noMentionsSelected' | localize"></span>
</agpr-message>

<!-- limit -->
<agpr-message
    *ngIf="(unsavedMentionExportLimit > 0) && (mentionCount > 0)"
    [severity]="mentionCount > remainingUnsavedMentionQuota ? messageSeverities.error : ((remainingUnsavedMentionQuota - mentionCount) > 100) ? messageSeverities.info : messageSeverities.warning"
>
    <span [innerHTML]="mentionType+'.postFeed.bulkActions.unusedMention.message' | localize : {
        unsavedCount: unsavedMentionQuotaUsage,
        unsavedLimit: unsavedMentionExportLimit,
        mentionsCount: mentionCount,
        adjective: (mentionCount > remainingUnsavedMentionQuota ? 'exceeds' : ((remainingUnsavedMentionQuota - mentionCount) > 100) ? 'isWithin' : 'isNear') | localize,
        remainingUnused: remainingUnsavedMentionQuota
    }"></span>
</agpr-message>
